import InnerHTML from 'dangerously-set-html-content';
import React, { useEffect } from 'react';
import { generateCode } from '../../store/form';
import {
    appCodeSelector,
    generatedCodeSelector,
    generatedUrlSelector,
    shortUrlSelector,
    widgetTypeSelector,
} from '../../store/form/selectors';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { Loading } from '../Loading/Loading';
import QRCode from '../QRCode/QRCode';
import styles from './Preview.module.scss';

export const Preview = () => {
    const widgetCodeString = useAppSelector(generatedCodeSelector);
    const { result: shortUrl, status: urlStatus } = useAppSelector(shortUrlSelector);
    const url = useAppSelector(generatedUrlSelector);
    const widgetType = useAppSelector(widgetTypeSelector);
    const appCode = useAppSelector(appCodeSelector);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(generateCode());
    }, [dispatch, widgetType, appCode]);
    return (
        <div className={styles['preview-container']}>
            {urlStatus === 'loading' ? (
                <Loading />
            ) : (
                <>
                    {widgetType !== 'qr' && widgetCodeString && (
                        <InnerHTML key={new Date().getTime()} html={widgetCodeString} />
                    )}
                    {widgetType === 'qr' && urlStatus === 'succeeded' && (
                        <QRCode testId="qr-preview" link={shortUrl} />
                    )}
                    {widgetType === 'qr' && urlStatus === 'failed' && (
                        <QRCode testId="qr-preview" link={url} />
                    )}
                </>
            )}
        </div>
    );
};
